/* assets/vipps-buy-button.js */
(function () {
  'use strict'

  function getVariantId() {
    var sel = document.querySelector('[data-product-select]')
    if (sel && sel.value) return sel.value
    var btn = document.querySelector('[data-vipps-button]')
    return btn ? btn.getAttribute('data-variant-id') : null
  }

  function setLoading(btn, loading) {
    var label = btn.querySelector('[data-vipps-label]')
    var spinner = btn.querySelector('.vipps-buy-button__spinner')
    btn.disabled = loading
    if (label) label.hidden = loading
    if (spinner) spinner.hidden = !loading
  }

  function handleClick(e) {
    var btn = e.currentTarget
    var variantId = getVariantId()
    if (!variantId) return

    setLoading(btn, true)
    window.location.href = '/cart/' + variantId + ':1'
  }

  function ensureVisible() {
    document.querySelectorAll('[data-vipps-buy]').forEach(function (wrapper) {
      wrapper.style.removeProperty('display')
      wrapper.hidden = false
    })
  }

  function init() {
    document.querySelectorAll('[data-vipps-button]').forEach(function (btn) {
      btn.addEventListener('click', handleClick)
    })

    var sel = document.querySelector('[data-product-select]')
    if (sel) {
      sel.addEventListener('change', function () {
        document.querySelectorAll('[data-vipps-button]').forEach(function (btn) {
          btn.setAttribute('data-variant-id', sel.value)
        })
        ensureVisible()
      })
    }

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant
      if (v) {
        document.querySelectorAll('[data-vipps-button]').forEach(function (btn) {
          btn.setAttribute('data-variant-id', v.id)
        })
      }
      ensureVisible()
    })

    ensureVisible()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
